
import LoleH2 from '~/components/text/lole-h2'
import LoleLink from '~/components/link/lole-link'
import LoleBtn from '~/components/buttons/lole-btn'
import LoleP from '~/components/text/lole-p'

export default {
  components: {
    LoleH2,
    LoleLink,
    LoleBtn,
    LoleP,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isExternalLink() {
      return !!this.blok.cta_banner_button_link.includes('http')
    },
  },
}
